export default {
  menu: {
    news: 'Information Centre',
    newsList: 'News',
    acti: 'Our business',
    contactUs: 'Contact Us',
    about: 'About us',
    recruit: 'Opportunities',
    home: 'Home',
    search: 'Search'
  },
  home: {
    technology: 'technology R & D',
    technologyName1: 'Tianchen: Caprolactam',
    technologyName2: 'Donghua: Syngas to ethylene glycol',
    technologyName3: 'Guilin Institute: rubber field technology',
    technologyName4: 'Hualu: Nanoscale silica-based aerogel',
    technologyName5: 'Chengda: Biodegradable Plastic PBS',
    technologyName6: 'WUHU: High Temperature Waste Gasification',
    technologyContent1: 'It broke through the monopoly and blockade of foreign technology, which is a low energy consuming and environment protective caprolactam production technology, which represents the latest level of caprolactam production in the world.',
    technologyContent2: 'Syngas to ethylene glycol technology provides technical support for the development of domestic coal to ethylene glycol industry, which significantly reduced production costs and provided  high-quality raw materials for the downstream chemical fiber and polyester industries with "polyester-grade" product quality.',
    technologyContent3: 'Five compound rubber extrusion line is a necessary extrusion equipment for the production of high-performance tires. The five compound rubber extrusion line has been purchased and used by Michelin, Zhongce Rubber, Linglong Tire and other famous tire enterprises at home and abroad.',
    technologyContent4: 'Supercritical fluid silicon-based aerogel technology, has completed the verification and optimization of the pilot plant, and the construction of 50,000m3/year aerogel composites project in Chongqing Chemical Industry Park.',
    technologyContent5: 'Technology for the preparation of succinic acid, a key monomer in the biodegradable plastic PBS, which can significantly reduce the production cost of succinic acid.',
    technologyContent6: 'Optimisation of the high-temperature waste gasification technology from Switzerland for the drying and compacting of unsorted municipal waste before direct gasification.',
    project: 'Project Performance',
    projectName1: 'Chemical Engineering',
    projectName2: 'Refinery',
    projectName3: 'Power',
    projectName4: 'Environmental',
    projectName5: 'Light industry, Pharmaceutical, Municipal',
    projectName5_1: 'Light industry',
    projectName5_2: 'Pharmaceutical, Municipal',
    projectContent1: 'CNCEC has extensive experience in chemical engineering, and has mastered and possessed a series of patented and proprietary technologies in many fields. It can provide engineering services in the whole process of planning, feasibility study, design, procurement, construction and start-up. The quality of engineering construction has reached the domestic and international advanced level.',
    projectContent2: 'China chemical is the first enterprise to design and construct oil refining engineering in China, and has participated in the construction of many large and medium-sized oil refining projects in China.',
    projectContent3: 'By utilizing its advantages in chemical engineer -ing technology, ChemChina also has rich experience in the field of energy storage and trans -potation and power station construction, and has achieved remarkable results both in China and abroad.',
    projectContent4: 'Sinochem has a professional R & D team of environmental protection technology, has participated in provincial, ministerial, and national scientific and technological breakthroughs for many times, and has a number of technologies, especially rich experience in the field of domestic industrial wastewater treatment.',
    projectContent5: 'By utilizing its own management, design and construction advantages, ChemChina actively participated in the construction of ports, road traffic, housing construction, light industry, medicine, municipalities and other fields, and won widespread praise for high engineering quality.',
    news: 'Information Centre',
    NewsRelease: 'Latest News'
  },
  about: {
    title: 'About us',
    name: 'China National Chemical Engineering Co., Ltd.',
    name1: 'History of Development',
    name2: 'Organization Chart',
    name3: 'About Company',
    name4: 'Contact us',
    name5: '会社概况',
    name6: '基本信息',
    developHistory: 'Establishment of the Heavy Industry Design Institute and Construction Company by the China Ministry of National Heavy Industry',
    developHistory1: '公司于2010年1月在上海证券交易所成功上市（代码：601117）',
    developHistory2: '在《Amenican Engineeing New Record》工程新闻纪录中的历史新高排名',
    developHistory3: '发布“三年五年规划，十年三十年目标愿学目标”，把科技和实业列为重要的发展战略，同年日本分院成立，成为中国化学历史上第一个海外研发机构',
    developHistory4: '2020年美国工程新闻杂志ENR评选的“全球最大250家工程承包商”排名第18、“全球最大250家国际承包商”排名第22',
    time: '成立时间：',
    local: '所在地',
    number: '员工数：',
    legal: '法人代表：',
    capital: '注册资本：',
    businessContent: '业务内容：',
    businessContentValue: '以化学化工为核心的先进技术研发及投资服务业务',
    timeValue: '2019年6月18日',
    localValue: '东京办公室〉東京都品川区西五反田8-1-3 PMO五反田10F',
    numberValue: '45人',
    legalValue: '高小放',
    capitalValue: '4億9000万日元',
    local1: '筑波科研中心：',
    localValue1: '筑波县筑波市东光台5-9-1',
    localValue2: '東京都品川区西五反田8-1-3 PMO五反田10F',
    telValue2: '03-5719-2660',
    faxValue2: '045-620-8845',
    tel: '电话：',
    telValue: '029-846-3481',
    fax: '传真：',
    faxValue: '029-847-4550',
    purpose: '用途：',
    purposeValue: '自主研发及共同研发',
    area: '面积：',
    areaValue: '1,000 ㎡',
    message: {
      name: 'name',
      eMail: 'e-mail',
      fax: 'fax',
      telephone: 'Contact us',
      companyName: 'Company Name',
      content: 'Content',
      securityCode: 'Verification Code',
      submit: 'Submit'
    },
    project: {
      title: '8 Engineering Companies',
      company1: '1. China Tianchen Engineering Co. Ltd.',
      company2: '2. Sedin Engineering Co. Ltd.',
      company3: '3. Donghua Engineering Technology Co.Ltd.',
      company4: '4. China WuHuan Engineering Co. Ltd.',
      company5: '5. Hua Lu Engineering&Technology Co.Ltd.',
      company6: '6. China Chengda Engineering Co. Ltd.',
      company7: '7. China Chemical Guilin Engineering Co. Ltd.',
      company8: '8. Chemical Industry Geotechnical Engineering Co. Ltd.',
    },
    build: {
      title: '10 Construction Companies',
      company1: '1. China Chemical Engineering Construction Corporation.',
      company2: '2. China National Chemical Engineering Third Construction Co. Ltd.',
      company3: '3. China National Chemical Engineering Fourth Construction Co. Ltd.',
      company4: '4. China National Chemical Engineering Sixth Construction Co. Ltd.',
      company5: '5. China National Chemical Engineering&Construction corporation seven Ltd.',
      company6: '6. China National Chemical Engineering The Ninth Construction Co. Ltd.',
      company7: '7. China Eleventh Chemical Construction Co. Ltd.',
      company8: '8. China National Chemical Engineering Thirteenth Construction Co. Ltd.',
      company9: '9. China National Chemical Engineering No.14 Construction Co. Ltd.',
      company10: '10. China National Chemical Engineering No.16 Construction Co. Ltd.',
    },
    hold: {
      title: 'Holdings in participating companies',
      company1: '1. Sichuan Shengda Chemical New Materials Co., Ltd.',
      company2: '2. Indonesia Sinochem Palembang Power Station Co., Ltd.',
      company3: '3. Sinochem Engineering Group Finance Co., Ltd.',
      company4: '4. Sinochem Engineering Group Environmental Protection Co., Ltd.',
      company5: '5. China Institute of Chemical Science and Technology.',
    },
    contact: {
      address: 'Address:',
      tell: 'Tell:',
      addressName: '〒141-0031 東京都品川区西五反田8丁目1-3  PMO五反田 10F 株式会社アクテイ。',
      phone: '+86 (010) 59765575'
    }
  },
  acti: {
    title: 'Our business',
    name: 'Advanced Chemical Technology Research Institute',
    name3: '筑波科研中心',
    name1: 'ACTI Business Fields',
    name2: 'ACTI Business Model',
    name4: '总部（横滨研发中心）',
    businessName1: 'New Material',
    businessContent1: 'Engineering plastics, special rubber and electronic chemicals',
    businessName2: 'Clean Energy',
    businessContent2: 'Hydrogen energy, solar energy and Bioenergy',
    businessName3: 'Green Environmental Protection',
    businessContent3: 'Efficient utilization of by products of three wastes treatment',
    businessName4: 'New Petrochemical Technology',
    businessContent4: 'Energy saving and consumption reducing intelligent equipment',
    modeName1: 'Technology introduction',
    modeContent1: 'Orientally fill domestic gaps and products and technologies which are in urgent need of upgrading, introduce technology by means of technical cooperation.',
    modeName2: 'Joint Development',
    modeContent2: 'Joint development projects with local industrial technology companies and universities and research institutes in Japan.',
    modeName3: 'Independent research and development',
    modeContent3: 'Focus on future technology trends, layout next-generation products and technologies, and cultivate proprietary technologies.',
    modeName4: 'Investment and M&A',
    modeContent4: 'Mergers and acquisitions of Japanese industry-related technology start-ups.',
    content: 'Established: June 18, 2019.<br>' +
              'Location：&#12288;Tokyo, Japan<br>' +
              'Employees：&#12288; 18<br>' +
              'Registered capital：490,000,000 yen, wholly owned subsidiary of ChemChina.<br>' +
              '<p class="line-indent">Positioning：Centering on chemical technology, targeting to build a platform with four functions of " research and development drive, cooperation and development, talent incubation and model innovation", relying on the Chinese market and focusing on Japanese advanced technology, actively promote the investment and cooperation between China and Japan in technology research and development and industry, helping to create a technologically innovative and environment-friendly future. </p><br>'
  },
  recruit: {
    title: 'Recruit Information',
    info: 'Position Information',
    name: 'Positions',
    local: 'Location',
    number: 'Number',
    time: 'Update time',
    rank: 'Rank',
    numberPeople: 'Number people',
    numberManagers: 'Number managers',
    supervisor: 'Supervisor',
    arriveTime: 'Arrive time',
    applyNow: 'Apply Now',
  },
  news: {
    title: 'Information Centre',
    allNews: 'All Information',
    newsRelease: 'News Release'
  },
  newsList: {
    title: 'Information Centre'
  },
  organizational: {
    title: 'ACTI Tsukuba laboratory',
    name: 'inside/outside'
  },
  search: {
    name: 'Search result',
    title: 'Search',
    btn: 'Search',
    noInfo: 'No search information',
  },
  project: {
    title: 'Project Performance',
    project1: 'Shenhua MTO project',
    project2: 'Bayer TDI project',
    project3: 'Vietnam urea ammonia project',
    project4: 'Fujian caprolactam project',
    project5: 'Dushanzi oil refining project in Xinjiang',
    project6: 'Diesel hydrogenation in Pakistan',
    project7: 'Shanghai LNG Terminal Project',
    project8: 'Combined cycle power station in Georgia',
    project9: 'Shanghai waste incineration project',
    project10: 'Inner Mongolia Shenhua CCS project',
    project11: 'Myanmar paper mill project',
    project12: 'Novo Nord biopharmaceutical factory project',
  },
  technology: {
    title: 'technology R & D'
  },
  footer: {
    help: {
      title: 'Help you... ...',
      question: 'Common questions',
      answers: 'Here you can get answers to more common questions',
      contactNow: 'Contact now',
      phone: 'Contacting via phone',
      process: 'If you are not satisfied with our service or process, or have any comments or complaints, please contact us through the following methods.',
      links: 'Links:',
      contactUs: '联系我们',
      tel: '电话: ',
      fax: '传真: ',
      eMail: '邮箱: '
    }
  },
  common: {
    viewDetails: 'View Details',
    more: 'More',
    contact: 'Contact',
    searchTitle: 'Please enter search title',
    phoneNotEmpty: 'Mobile phone number cannot be empty',
    pleaseEnterPhone: 'Please input the correct mobile phone number',
    pleaseEnterContent: 'Please input the content',
    pleaseEnterSecurityCode: 'Please input the Verification Code',
    submitSuccess: 'Submit success',
    verificationCodeError: 'Submit error'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js